import type { ElementType, ReactNode } from 'react';

import styles from './Card.module.css';

interface CardProps {
  children: ReactNode;
  as?: ElementType | undefined;
  /** Приподнимается при наведении — только для кликабельных карточек. */
  interactive?: boolean | undefined;
  padding?: 'sm' | 'md' | 'lg' | 'none' | undefined;
  className?: string | undefined;
}

export function Card({
  children,
  as: Tag = 'div',
  interactive = false,
  padding = 'md',
  className,
}: CardProps) {
  return (
    <Tag
      className={[styles.card, styles[`p-${padding}`], interactive && styles.interactive, className]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </Tag>
  );
}
